import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "AI Foundations & Computational Thinking",
    description:
      "Introduction to AI, AI vs ML vs DL vs Data Science, History, applications & future of AI, Problem-solving approaches, Logic, reasoning & intelligent systems",
  },
  {
    title: "Python Programming for Intelligent Systems",
    description:
      "Python Essentials,Python fundamentals for AI, NumPy, Pandas, Matplotlib, Data structures & algorithms basics, Working with Jupyter Notebook, Mini AI coding exercises",
  },
  {
    title: "Mathematical Intelligence & Statistical Fundamentals",
    description:
      "Maths & Stats for AI,Linear algebra for AI (vectors, matrices), Calculus basics (derivatives, gradients), Probability & statistics, Optimization concepts, Cost functions & error metrics",
  },
  {
    title: "Machine Learning Algorithms & Predictive Intelligence",
    description:
      "ML Basics,Supervised learning: Regression, Classification, Unsupervised learning: Clustering, PCA, Model training, testing & validation, Overfitting, underfitting & tuning, Real-world ML workflows",
  },
  {
    title: "Deep Learning & Neural Network Engineering",
    description:
      "Introduction to Deep Learning,Artificial Neural Networks (ANN), Activation & loss functions, Forward & backward propagation, TensorFlow & Keras fundamentals, Hands-on neural network building.",
  },
  {
    title: "Computer Vision & Image Intelligence",
    description:
      "Vision Basics,Understanding images as data, Convolutional Neural Networks (CNNs), Image classification models, Face detection & object detection basics, OpenCV hands-on projects",
  },
  {
    title: "Natural Language Processing & Text Intelligence",
    description:
      "NLP Concepts,Text preprocessing & embeddings, Bag of Words, TF-IDF, Word2Vec & vector representations, Sentiment analysis, Chatbot basics & text classification",
  },
  {
    title: "Generative AI & Large Language Models (LLMs)",
    description:
      "AI Advancements,LLMs, Prompt engineering, Fine-tuning basic models, Image, text & audio generation, Real-world GenAI applications",
  },
  {
    title: "AI Deployment, MLOps & Real-world Integration",
    description:
      "Deployment & DevOps,Deploying AI models on cloud, APIs for AI apps, CI/CD introduction, Model monitoring & versioning, Scalable AI app development",
  },
  {
    title: "Robotics, Automation & Intelligent Systems",
    description:
      "AI Use Cases,Basics of robotics, Sensors & control systems, Path planning & automation logic, AI-powered automation workflows, Industry 4.0 fundamentals",
  },
  {
    title: "Capstone AI Project – Industry Aligned",
    description:
      "Project,Solve a real-world AI problem, Data collection → model building → deployment, Explainability & documentation, End-to-end AI system creation, Final presentation",
  },
  {
    title: "Portfolio Development & Career Roadmap",
    description:
      "Career Prep,AI project portfolio building, GitHub profile optimization, AI/ML interview preparation, Resume for AI roles, Career guidance for top job roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
